module.exports = {"340811001":"大桥街道","340811100":"大龙山镇","340811101":"杨桥镇","340811102":"罗岭镇","340811200":"白泽湖乡","340811201":"五横乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340811.json
// module id = 1005
// module chunks = 0